import contract from './flowerCompositionFields.json';
export const FLOWER_MANIFEST_KEY = contract.fact_key;
export { contract as flowerCompositionContract };
const keysOnly = (value, keys) => value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).every(k => keys.includes(k));
const string = (value, max, required = false) => typeof value === 'string' && value.length <= max && (!required || value.trim().length > 0);
export function canonicalFlowerNumber(value, spec) {
 if(typeof value !== 'string' || !/^(?:0|[1-9]\d{0,11})(?:\.\d{1,6})?$/.test(value)) return null;
 const [whole, decimal = ''] = value.split('.');
 const fraction = decimal.replace(/0+$/, '');
 if(spec.integer && fraction) return null;
 // The grammar limits the whole part to 12 digits, below Number's exact integer limit.
 if(spec.maximum !== undefined && (Number(whole) > Number(spec.maximum) || (Number(whole) === Number(spec.maximum) && fraction))) return null;
 return whole + (fraction ? '.' + fraction : '');
}
// Only observable fields and source records pass; no classification conclusions are accepted.
export function validateFlowerManifest(manifest) {
 const invalid = reason => ({valid:false, status:'invalid', reason, conflicts:[]});
 if(!keysOnly(manifest,['schema','inventory_complete','confirmed','paused','components']) || manifest.schema !== 1
  || !['inventory_complete','confirmed','paused'].every(k => typeof manifest[k] === 'boolean')
  || !Array.isArray(manifest.components) || manifest.components.length > 64) return invalid('구성품 명세 형식을 확인해 주세요.');
 const ids = new Set(), conflicts = [];
 let missing = false;
 for(const component of manifest.components) {
  if(!keysOnly(component,['id','label','observations']) || !string(component.id,64,true) || ids.has(component.id)
   || !string(component.label,200,true) || !Array.isArray(component.observations) || component.observations.length > 100) return invalid('구성품 이름·식별값·관찰 항목을 확인해 주세요.');
  ids.add(component.id);
  const values = new Map();
  for(const observation of component.observations) {
   const spec = Object.prototype.hasOwnProperty.call(contract.fields,observation?.field) ? contract.fields[observation.field] : null;
   if(!keysOnly(observation,['field','value','unit','source']) || !spec
    || !keysOnly(observation.source,['type','locator','quote']) || !Object.prototype.hasOwnProperty.call(contract.source_types,observation.source.type)
    || !string(observation.source.locator,500,observation.source.type !== 'user_statement')
    || !string(observation.source.quote,2000,true)) return invalid('관찰값과 출처를 확인해 주세요.');
   const value = spec.type === 'decimal' ? canonicalFlowerNumber(observation.value,spec)
    : typeof observation.value === 'string' && Object.prototype.hasOwnProperty.call(spec.options,observation.value) ? observation.value : null;
   if(value === null || observation.unit !== (spec.unit || '')) return invalid(`${spec.label}의 값과 단위를 확인해 주세요.`);
   if(!values.has(observation.field)) values.set(observation.field,new Set());
   values.get(observation.field).add(value);
  }
  for(const [field, candidates] of values) if(candidates.size > 1) conflicts.push({component_id:component.id,field,
   observations:component.observations.filter(o => o.field === field)});
  if(!values.has('kind')) missing = true;
 }
 return {valid:true, conflicts, status:manifest.paused ? 'paused' : conflicts.length ? 'conflict'
  : !manifest.confirmed ? 'confirmation_required' : !manifest.inventory_complete || !manifest.components.length || missing ? 'incomplete' : 'observations_ready'};
}
